import { FC } from 'react'
import { useTheme } from '@emotion/react'

// icons
import { icons } from '@/assets'
// hooks
import { useAppDispatch } from '@/hooks'
// features
import { reportCloseReportTrackModal } from '@/features'
// components
import { CardHeaderMobile, ModalCardTitle, ModalCardSubtitle, Error } from '@/components'

// components
import { ReportTrackForm } from './components'
// styles
import { styles } from './styles'

type ReportTrackCardProps = {}

export const ReportTrackCard: FC<ReportTrackCardProps> = () => {
  const theme = useTheme()

  const dispatch = useAppDispatch()
  const reportTrackError = ''

  return (
    <div
      css={styles(theme).card.main}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      {/* mobile header */}
      <div css={styles(theme).card.header}>
        <CardHeaderMobile onCloseClick={() => dispatch(reportCloseReportTrackModal())} />
      </div>

      {/* title */}
      <div css={styles(theme).card.title}>
        <ModalCardTitle text="Report" icon={icons.AlertTriangle} />
      </div>

      {/* subtitle */}
      <div css={styles(theme).card.subtitle}>
        <ModalCardSubtitle text="Kindly provide details of your concern regarding this track." />
      </div>

      <div css={styles(theme).card.content.main}>
        {/* form */}
        <div css={styles(theme).card.content.form}>
          <ReportTrackForm />
        </div>

        <div css={styles(theme).card.content.error}>
          <Error error={reportTrackError} />
        </div>
      </div>
    </div>
  )
}

ReportTrackCard.propTypes = {}
